// worked well with remove profile picture function
import React, { useEffect, useState } from 'react';
import Cookies from "js-cookie";
import api from '../utils/axiosInstance';
import { useImmerReducer } from 'use-immer';
import { Button, TextField, Container, Typography, Box, Grid, Avatar, CircularProgress, IconButton } from '@mui/material'; 
import HomeIcon from '@mui/icons-material/Home';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import defaultProfilePicture from "./Assets/default3.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from "react-toastify";
import axios from 'axios';

function Profile() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const initialState = {
    userProfile: {
      agencyNameValue: "",
      phoneNumberValue: "",
      bioValue: "",
      sellerId: "",
      sellerListings: [],
      uploadedPicture: [],
      profilePictureValue: "",
    },
    sendRequest: 0,
    userFullName: "",  // Track user's full name
    dataIsLoading: true,
    removeProfilePicture: false, // To track if the user wants to remove the profile picture
  };

  function ReducerFunction(draft, action) {
    switch (action.type) {
      case "catchUserProfileInfo":
        draft.userProfile.agencyNameValue = action.profileObject.agency_name || "";
        draft.userProfile.phoneNumberValue = action.profileObject.phone_number || "";
        draft.userProfile.bioValue = action.profileObject.bio || "";
        draft.userProfile.profilePictureValue = action.profileObject.profile_picture || "";
        draft.userProfile.sellerListings = action.profileObject.seller_listings || "";
        draft.userProfile.sellerId = action.profileObject.seller || "";
        break;
      case "catchAgencyNameChange":
        draft.userProfile.agencyNameValue = action.agencyNameChosen;
        break;
      case "catchPhoneNumberChange":
        draft.userProfile.phoneNumberValue = action.phoneNumberChosen;
        break;
      case "catchBioChange":
        draft.userProfile.bioValue = action.bioChosen;
        break;
      case "catchUploadedPicture":
        draft.userProfile.uploadedPicture = action.pictureChosen;
        draft.removeProfilePicture = false;  // Reset remove picture state if a new picture is uploaded
        break;
      case "catchProfilePictureChange":
        draft.userProfile.profilePictureValue = action.profilePictureChosen;
        break;
      case "removeProfilePicture": // Add case to handle profile picture removal
        draft.userProfile.profilePictureValue = "";
        draft.removeProfilePicture = true; // Set this flag to true
        break;
      case "changeSendRequest":
        draft.sendRequest += 1;
        break;
      case "setUserFullName": // Add this case to set the full name
        draft.userFullName = action.payload;
        break;
      case "loadingDone":
        draft.dataIsLoading = false;
        break;
      default:
        break;
    }
  }

  const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

  // Watch for changes to the uploaded picture and update profile picture value
  useEffect(() => {
    if (state.userProfile.uploadedPicture && state.userProfile.uploadedPicture.length > 0) {
      dispatch({
        type: "catchProfilePictureChange",
        profilePictureChosen: state.userProfile.uploadedPicture[0] // Set the file in the state
      });
    }
  }, [state.userProfile.uploadedPicture]);
  
  useEffect(() => {
    async function GetProfileInfo() {
      try {
        const userCookie = Cookies.get('user');
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
        const response = await api.get(`${apiUrl}/api/profile/${userId}/`);
        
        dispatch({
          type: "catchUserProfileInfo",
          profileObject: {
            ...response.data,
            profile_picture: response.data.profile_picture_url || ""
          }
        });

        dispatch({type: 'loadingDone'})

        // Set the user's full name from cookie if available
        if (userCookie) {
          const parsedCookie = JSON.parse(userCookie);
          dispatch({ type: "setUserFullName", payload: parsedCookie.names || "User" });
        }
      } catch (e) {
        console.log(e.response);
      }
    }
    GetProfileInfo();
  }, []);

  useEffect(() => {
    if (state.sendRequest) {
      async function UpdateProfile() {
        const formData = new FormData();
        const userCookie = Cookies.get('user'); 
        const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  
        if (!userId) {
          console.error("User ID not found in cookies");
          toast.error("User not authenticated. Please log in.");
          return;
        }
  
        // Append all the form data fields correctly
        formData.append("agency_name", state.userProfile.agencyNameValue);
        formData.append("phone_number", state.userProfile.phoneNumberValue);
        formData.append("bio", state.userProfile.bioValue);
  
        // Append the profile picture if it exists and is a file, otherwise check if it's being removed
        if (state.removeProfilePicture) {
          formData.append("profile_picture", ""); // Send empty profile picture to backend
        } else if (state.userProfile.profilePictureValue && typeof state.userProfile.profilePictureValue !== 'string') {
          formData.append("profile_picture", state.userProfile.profilePictureValue);
        }
  
        try {
          const response = await api.patch(
            `${apiUrl}/api/profile/${userId}/update/`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } } // Ensure multipart header
          );
          
          // Success message
          if (response.status === 200) {
            toast.success("Profile updated successfully.");
            navigate(0); // Reload page to reflect the update
          }
        } catch (e) {
          setIsLoading(false);
  
          // Handle different error responses and display corresponding messages
          if (e.response && e.response.status === 400) {
            console.error("Validation error:", e.response.data);
            toast.error("Validation error. Please check your input.");
            
            const errorData = e.response.data;
            for (let field in errorData) {
              if (errorData[field]) {
                toast.error(`${field}: ${errorData[field].join(', ')}`);
              }
            }
          } else if (e.response && e.response.status === 401) {
            console.error("Unauthorized:", e.response.data);
            toast.error("Unauthorized access. Please log in again.");
          } else if (e.response && e.response.status === 429) {
            console.error("Rate limit exceeded:", e.response.data);
            toast.error("Too many requests. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", e.message);
            toast.error("An unexpected error occurred. Please try again.");
          }
        }
      }
  
      UpdateProfile();
    }
  }, [state.sendRequest]);
  
  // Send the profile update request when needed and this worked perfectly. i just added toast above for success and errors
  // useEffect(() => {
  //   if (state.sendRequest) {
  //     async function UpdateProfile() {
  //       const formData = new FormData();
  //       const userCookie = Cookies.get('user'); 
  //       const userId = userCookie ? JSON.parse(userCookie).user_id : null;
  
  //       if (!userId) {
  //         console.error("User ID not found in cookies");
  //         return;
  //       }
  
  //       // Append all the form data fields correctly
  //       formData.append("agency_name", state.userProfile.agencyNameValue);
  //       formData.append("phone_number", state.userProfile.phoneNumberValue);
  //       formData.append("bio", state.userProfile.bioValue);
  
  //       // Append the profile picture if it exists and is a file, otherwise check if it's being removed
  //       if (state.removeProfilePicture) {
  //         formData.append("profile_picture", ""); // Send empty profile picture to backend
  //       } else if (state.userProfile.profilePictureValue && typeof state.userProfile.profilePictureValue !== 'string') {
  //         formData.append("profile_picture", state.userProfile.profilePictureValue);
  //       }
  
  //       try {
  //         const response = await api.patch(
  //           `http://localhost:8000/api/profile/${userId}/update/`,
  //           formData,
  //           { headers: { 'Content-Type': 'multipart/form-data' } } // Ensure multipart header
  //         );
  //         console.log(response.data);
  //         navigate(0);
  //       } catch (e) {
  //         console.log(e.response);
  //       }
  //     }
  //     UpdateProfile();
  //   }
  // }, [state.sendRequest]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({ type: 'changeSendRequest' });
  };

  function PropertiesDisplay() {
    if (state.userProfile.sellerListings.length === 0) {
      return (
        <Button disabled size="small" >No Property</Button>
      );
    } else if (state.userProfile.sellerListings.length === 1) {
      return (
        <Button size='small' 
        onClick={()=>navigate(`/agency/${state.userProfile.sellerListings[0].seller}`)}>1 Property Listed</Button>
      );
    } else {
      return (
        <Button size='small'
        onClick={()=>navigate(`/agency/${state.userProfile.sellerListings[0].seller}`)}>{state.userProfile.sellerListings.length} Properties Listed</Button>
      )
    }
  }

  function WelcomeDisplay() {
    return (
      <Grid container spacing={2} alignItems="center" direction="column">
        <Grid item>
          <Typography variant="h5">
            Welcome, <span style={{ fontWeight: 'bold' }}>{state.userFullName || 'User'}</span>!
          </Typography>
          {state.userProfile.agencyNameValue === "" || state.userProfile.phoneNumberValue === "" ? (
            <Typography variant="body1">
              Please fill out the form below to update your profile.
            </Typography>
          ) : (
            <Typography variant="h6" style={{ textAlign: 'center' }}>
              {PropertiesDisplay()}
            </Typography>
          )}
        </Grid>
        <Grid item>
          {/* {state.userProfile.profilePictureValue ? (
            <Avatar
              src={typeof state.userProfile.profilePictureValue === 'string'
                ? state.userProfile.profilePictureValue  // Use URL if it's a string
                : URL.createObjectURL(state.userProfile.profilePictureValue)}  // Use file object for new uploads
              alt="Profile Picture"
              sx={{ width: 150, height: 150 }}
            />
          ) : (
            <Avatar
               src={typeof state.userProfile.profilePictureValue !== null
                ? state.userProfile.profilePictureValue
                : defaultProfilePicture
               }
               alt="Profile Picture"
               sx={{ width: 150, height: 150 }}
            />
          )} */}
          
          {state.userProfile.profilePictureValue ? (
            <Avatar
              src={
                typeof state.userProfile.profilePictureValue === 'string'
                  ? state.userProfile.profilePictureValue
                  : URL.createObjectURL(state.userProfile.profilePictureValue)
              }
              alt="Profile Picture"
              sx={{ width: 150, height: 150 }}
            />
          ) : (
            <Avatar
              src={defaultProfilePicture}
              alt="Profile Picture"
              sx={{ width: 150, height: 150 }}
            />
          )}
        </Grid>
      </Grid>
    );
  }

  if (state.dataIsLoading === true) {
    return(
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    )
  }
  
  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={2}>
        <HomeIcon fontSize="large" />
        <Typography variant="h4" ml={1}>
          Profile
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={4}>
        {WelcomeDisplay()}
      </Box>
      <Container maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <TextField
            label="Agency Name"
            value={state.userProfile.agencyNameValue}
            onChange={(e) =>
              dispatch({
                type: "catchAgencyNameChange",
                agencyNameChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          <TextField
            label="Phone Number"
            value={state.userProfile.phoneNumberValue}
            onChange={(e) =>
              dispatch({
                type: "catchPhoneNumberChange",
                phoneNumberChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
            required
          />
          <TextField
            label="Bio"
            value={state.userProfile.bioValue}
            onChange={(e) =>
              dispatch({
                type: "catchBioChange",
                bioChosen: e.target.value,
              })
            }
            variant="outlined"
            margin="normal"
            fullWidth
          />
          <Button component='label' variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
            Upload Profile Picture
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                dispatch({
                  type: "catchUploadedPicture",
                  pictureChosen: e.target.files,
                })
              }
            />
          </Button>

          {state.userProfile.profilePictureValue && (
            <Box display="flex" alignItems="center" mb={1}>
              <Typography variant="subtitle1">
                {typeof state.userProfile.profilePictureValue === "string"
                  ? `${state.userProfile.profilePictureValue.split('/').pop()}`
                  : state.userProfile.profilePictureValue.name}
              </Typography>
              <IconButton
                aria-label="delete"
                onClick={() => dispatch({ type: "removeProfilePicture" })}
                fullwidth="true"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          )}

          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 2 }}>
            Update Profile
          </Button>
        </form>
      </Container>
    </>
  );
}

export default Profile;